import { useImperativeHandle, useState } from "react";

import { GetFieldNamesFromId } from "@/Utils/DataLib";
import { isNullish } from "@theorgchartdev/storybook";
import { PlanFieldsModal } from "@/appComponents/Blocks/Modals/PlanFieldsModal";
import { UpdatePlans } from "@/Utils/Promises";
import { enumObjClassNames, kDefaultPlanFields } from "@coreapp/constants";
import { IsPositionChart } from "@coreapp/utils/IsPositionChart";
import { DEFAULT_POSITION_PLAN_FIELDS } from "@coreapp/CoreApp/position-management.constants";
import { GetDoc } from "@/Utils/StateLib";

export const CurrentPlanFieldsModal = props => {
  const { planMgr } = props;

  const [fieldsMgr, setFieldsMgr] = useState(null); // Null | { defaultFields: { holder: [], position: [] }, additionalFields: [ holder: [], position: [] ] }
  useImperativeHandle(props.handleRef, () => ({
    handleOpen
  }));

  const isPosPlan = planMgr?.IsPositionPlan();

  const handleOpen = () => {
    const doc = planMgr.GetDoc();
    const planInfo = planMgr.GetPlanInfo();
    const defaultHolderFields = GetFieldNamesFromId(
      isPosPlan ? DEFAULT_POSITION_PLAN_FIELDS.holder : kDefaultPlanFields,
      enumObjClassNames.box,
      doc
    );
    const defaultPositionFields = isPosPlan
      ? GetFieldNamesFromId(DEFAULT_POSITION_PLAN_FIELDS.position, enumObjClassNames.position, doc)
      : [];

    const additionalFields = planInfo.fields;

    setFieldsMgr({
      defaultFields: { holder: defaultHolderFields, position: defaultPositionFields },
      additionalFields
    });
  };

  const handleClose = () => {
    setFieldsMgr(null);
  };

  const handleChange = fields => {
    setFieldsMgr(prevState => ({ ...prevState, additionalFields: fields }));
  };

  const handleSave = async () => {
    if (isNullish(fieldsMgr)) {
      return;
    }
    const ID = parseInt(planMgr.GetPlanID());
    const additionalFields = fieldsMgr?.additionalFields;
    await UpdatePlans(
      {
        ID,
        fields: additionalFields
      },
      "saveplan"
    );

    planMgr.UpdateFields(additionalFields);
    planMgr.SimulateSaveFeedback();
  };

  return (
    <PlanFieldsModal
      show={!isNullish(fieldsMgr)}
      onClose={handleClose}
      onChange={handleChange}
      onSave={handleSave}
      defaultFields={fieldsMgr?.defaultFields}
      additionalFields={fieldsMgr?.additionalFields}
      isPositionPlan={planMgr.IsPositionPlan()}
    />
  );
};
